<div class="p-col-12 p-grid p-d-flex p-ai-center pb-0 p-text-uppercase">
    <div class="p-col p-grid pb-0">
        <div class="p-md-11 p-lg-12 p-d-none p-d-md-inline-flex p-jc-center pb-0">
            <div class="dropdown navItem" *ngFor="let item of items">
                <div *ngIf="!item.items">
                    <a routerLink="{{ item.url }}">{{ item.id | translate }}<i *ngIf="item.items" class="navSubMenu pi pi-chevron-down"></i></a>
                </div>
                <div *ngIf="item.items">
                    <p class="menuItem">{{ item.id | translate }}<i *ngIf="item.items" class="navSubMenu pi pi-chevron-down"></i></p>
                </div>
                <div class="dropdown-content" *ngIf="item.items">
                    <a *ngFor="let subItem of item.items" routerLink="{{ subItem.url }}">{{ subItem.id | translate }}</a>
                </div>
            </div> 
        </div>
        <div class="p-col-12 p-md-1 p-d-flex p-d-inline-flex p-jc-end p-ai-center pb-0">
            <div class="navItem p-d-md-none" (click)="toggleShowMobileMenu()"><i class="pi pi-bars"></i></div>
        </div>
    </div>
</div>
<div class="p-col-12 p-d-md-none" *ngIf="showMobileMenu">
    <div class="navItem" *ngFor="let item of items; let index = index;">
        <div class="p-col-12 p-grid p-d-flex p-ai-center">
            <a style="width: auto;" routerLink="{{ item.url }}">{{ item.id | translate }}</a>
            <i *ngIf="item.items" (click)="indexMobileSubMenu === index ? indexMobileSubMenu = -1 : indexMobileSubMenu = index" class="navSubMenu pi pi-chevron-down"></i>        
        </div>
        <div *ngIf="item.items && indexMobileSubMenu === index">
            <a class="mobileSubLink" *ngFor="let subItem of item.items" routerLink="{{ subItem.url }}">{{ subItem.id | translate }}</a>
        </div>
    </div>
</div>